import http from './httpService';
/*global API */

const emailEndpoint = `${API}/api/Email`;

export function sendEmail(email) {
  return http.post(emailEndpoint + '/sendEmail', {
    eMailAddress: email.address,
    subject: email.subject,
    content: email.content,
  });
}
